module.exports = __webpack_public_path__ + "static/media/image-2.a838d512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-2.png
// module id = 2198
// module chunks = 0